import { StageCard } from "./types";

export const getCardFrontendUrl = (stageDetails: StageCard) => {

    if (stageDetails.isAdmin) {
        return `http://sandbox.admin-${stageDetails.stageDetails.name}-foodradar.delectame.com`;
    }

    return `http://sandbox.${stageDetails.stageDetails.name}-foodradar.delectame.com`;
}

export const getCardBackendUrl = (stageDetails: StageCard) => {
    if (stageDetails.isAdmin) {
        return `https://sandbox.admin-${stageDetails.stageDetails.name}-foodradar-backend.delectame.com`
    }

    return `https://sandbox.${stageDetails.stageDetails.name}-backend-foodradar.delectame.com`
}

export const getGithubLink = (statageDetails: StageCard) => {
    const githubProject = statageDetails.isAdmin ? "foodradarapp_admin" : "foodradarapp";

    return `https://github.com/delectatech/${githubProject}/tree/${statageDetails.gitDetails.branch}`
}